<template>
  <div class="d-flex align-center gap-2">
    <v-tooltip bottom max-width="300">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          :disabled="disabled"
          color="success"
          :loading="loadingSummary"
          @click="getExcel('summary')"
          text
          v-bind="attrs"
          v-on="on"
          class="font-weight-black text-uppercase tracking-widest rounded-lg px-4 transition-fast-in-fast-out h-44"
        >
          <v-icon left size="16">fas fa-list-ul</v-icon>
          Resumen
        </v-btn>
      </template>
      <span class="caption">
        Excel con Resumen de OTs (rápido)<br>
        <span class="grey--text text--lighten-1">Nro, Cliente, Proyecto, Avance, etc.</span>
      </span>
    </v-tooltip>

    <v-tooltip bottom max-width="300">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          :disabled="disabled"
          color="primary"
          :loading="loadingDetail"
          @click="getExcel('detail')"
          text
          v-bind="attrs"
          v-on="on"
          class="font-weight-black text-uppercase tracking-widest rounded-lg px-4 transition-fast-in-fast-out h-44"
        >
          <v-icon left size="16">fas fa-info-circle</v-icon>
          Detallado
        </v-btn>
      </template>
      <span class="caption">
        Excel con Detalle de Productos (completo)<br>
        <span class="grey--text text--lighten-1">Items, SKU, Cantidad, Mts2, Línea, Etapa</span>
      </span>
    </v-tooltip>
  </div>
</template>

<script>
import notifications from '@/utils/notifications'
import {excelWorkOrders} from '@/api/production'
import moment from 'moment'

export default {
  name: "ExportWorkOrders",
  props: ['filter', 'options', 'disabled', 'search'],
  data() {
    return {
      loadingSummary: false,
      loadingDetail: false,
    }
  },
  methods: {
    async getExcel(type) {
      if (type === 'summary') {
        this.loadingSummary = true
      } else {
        this.loadingDetail = true
      }

      let created_before = ''
      let created_after = ''
      if (this.filter.created_after) created_after = moment(this.filter.created_after).utc().format('YYYY-MM-DD HH:mm')
      if (this.filter.created_before) created_before = moment(this.filter.created_before).utc().add(1439, 'minutes').format('YYYY-MM-DD HH:mm')

      const { sortBy, sortDesc } = this.options
      const ordering = sortBy && sortBy[0]
        ? (sortDesc && sortDesc[0] ? `${sortBy[0]}` : `-${sortBy[0]}`)
        : '-created_at'

      const params = new URLSearchParams({
        type: type,
        created_after: created_after,
        created_before: created_before,
        delivery_after: this.filter.delivery_after || '',
        delivery_before: this.filter.delivery_before || '',
        completed: this.filter.status === null ? '' : (this.filter.status),
        sales_note__customer__seller: this.filter.seller || '',
        search: this.search || '',
        ordering: ordering,
      })

      const fileName = type === 'summary'
        ? `resumen_ots_${moment().format('DD-MM-YYYY_HHmm')}.xlsx`
        : `detalle_ots_${moment().format('DD-MM-YYYY_HHmm')}.xlsx`

      await excelWorkOrders(params.toString())
        .then((response) => {
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(response)
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)

          const msg = type === 'summary'
            ? 'Resumen de OTs exportado'
            : 'Detalle de OTs exportado'
          notifications.showSuccess(msg)
        })
        .catch((error) => {
          const msg = error.code == "ECONNABORTED" ? 'Tiempo de espera excedido' : 'Error al exportar'
          notifications.showError(msg)
        })
        .finally(() => {
          if (type === 'summary') {
            this.loadingSummary = false
          } else {
            this.loadingDetail = false
          }
        })
    },
  }
}
</script>

<style scoped>
.h-44 { height: 44px !important; }
.tracking-widest { letter-spacing: 1.5px; }
.gap-2 { gap: 8px; }
</style>
